import { BASE_API_URL } from '../../utils/api'
import apiClient from '../../utils/apiClient'

export const fetchDepartments = async () => {
  const { data } = await apiClient.get(`${BASE_API_URL}/support-ticket/department`)
  return data
}

export const createTicket = async (payload: any) => {
  const { data } = await apiClient.post(`${BASE_API_URL}/support-ticket/create`, payload)
  return data
}

export const getTickets = async () => {
  const { data } = await apiClient.get(
    `${BASE_API_URL}/support-ticket/many?join=department||localization,name`,
  )
  return data
}

// close ticket, by passing status of Closed
export const closeTicket = async (id: string) => {
  const { data } = await apiClient.patch(`${BASE_API_URL}/support-ticket/${id}`, {
    status: 'Closed',
  })
  return data
}

// add ticket comment
// payload should be text,ticketId, attachments optional, affiliateUserId
export const addTicketComment = async (payload: any) => {
  const headers = payload instanceof FormData 
    ? { 'Content-Type': 'multipart/form-data' }
    : { 'Content-Type': 'application/json' }
    
  const { data } = await apiClient.post(`${BASE_API_URL}/support-ticket/comment`, payload, { headers })
  return data
}
